import { cn } from '@/lib/utils'
import { type HTMLAttributes, forwardRef } from 'react'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'default' | 'small' | 'large'
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, size = 'default', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'mx-auto px-4 sm:px-6 lg:px-8',
          {
            'max-w-7xl': size === 'default',
            'max-w-5xl': size === 'small',
            'max-w-[1448px]': size === 'large',
          },
          className
        )}
        {...props}
      />
    )
  }
)

Container.displayName = 'Container'
